module.exports = __webpack_public_path__ + "img/hero-so-glad.82b92276.svg";